import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDealersUsers } from '@/api/dealers-users';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import router from '@/router';
import { isSuperAdmin } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.dealerId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      code: undefined,
      id: undefined,
      fullName: undefined,
      emailAddress: undefined,
      mobileNumber: undefined,
      enabled: true,
      dealerId: undefined,
      sort: 'id,DESC',
      filter: {
        emailAddress: '$contL',
        fullName: '$contL',
        mobileNumber: '$startsL',
        enabled: '$eq',
        id: '$eq',
        dealerId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }, {
      label: 'Order Ascending',
      key: 'totalOrderCount,ASC'
    }, {
      label: 'Order Descending',
      key: 'totalOrderCount,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.dealerId = parseInt(this.$route.params && this.$route.params.dealerId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      if (this.dealerId) {
        this.listQuery.dealerId = this.dealerId;
        const data = await getDealersUsers(getQuery(this.listQuery));
        this.list = data.data;
        this.total = data.total;
      } else {
        this.list = [];
        this.total = 0;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'enabled', 'Full Name', 'Mobile Number', 'Email Address', 'Is Mobile', 'Broker Name', 'Broker Mobile Number', 'Organization', 'GST Number', 'PAN Number', 'Wallet Balance', 'Wallet Usage Amount', 'Last Login', 'createdTimestamp'];
    const filterVal = ['id', 'enabled', 'fullName', 'mobileNumber', 'emailAddress', 'isMobile', 'broker.name', 'broker.mobileNumber', 'organization.name', 'organization.gstNumber', 'organization.panNumber', 'walletBalance', 'walletUsageAmount', 'pushUpdatedTimestamp', 'createdTimestamp'];
    const userFilter = Object.assign({}, this.listQuery);
    delete userFilter.limit;
    delete userFilter.page;
    const data2 = await getDealersUsers(getQuery(userFilter));
    const data = formatJson(filterVal, data2);
    exportJson2Excel(tHeader, data, this.$tc('route.dealerManagement.user.title'));
    this.downloadLoading = false;
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  editUser(userId = 0) {
    const query = this.listQuery;
    // delete query.filter;
    router.push({
      path: '/dealers-users/edit/' + userId
    });
  }
};
default_1 = __decorate([Component({
  name: 'DealersUserList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;